module.exports = __webpack_public_path__ + "static/img/c1.13151288.png";